import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { InputCheckbox, Modal } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { BrandContext } from '../../contextProviders/brandContext';
import { FORM_KEYS } from '../../constants/formKeys';

export const TermsOfUsePopup = ({ onNext }) => {
  const fieldFormContext = useFormContext();
  const { watch } = fieldFormContext;
  const {
    activeBrandContext: {
      cspConfiguration: { termsOfUseUrl }
    }
  } = useContext(BrandContext);

  const termsOfUseChecked = watch('termsOfUse');

  return (
    <Modal
      customCssClass="termsOfUsePopup"
      size="xsmall"
      showCloseIconButton={false}
      showFooterDivider
      open
      header={
        <h2
          id="dialog_label"
          className="modal-title"
        >
          MyPet Portal Terms of Use
        </h2>
      }
      footer={
        <button
          onClick={() => onNext()}
          type="button"
          className="button primary nextButton"
          disabled={!termsOfUseChecked}
        >
          <span>Next</span>
        </button>
      }
    >
      <fieldset>
        <InputCheckbox
          fieldFormContext={fieldFormContext}
          name={FORM_KEYS.TERMS_OF_USE}
          customCssClass="termsOfUseCheckbox"
          label={
            <span>
              I agree to the{' '}
              <a
                href={termsOfUseUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="termsOfUseUrl"
              >
                Terms of Use
              </a>{' '}
              of the portal
            </span>
          }
        />
      </fieldset>
    </Modal>
  );
};

TermsOfUsePopup.propTypes = {
  onNext: PropTypes.func
};
